import { useContext, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { GROUP_ROLES } from '@helpers';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { groupsQuery, usersQuery } from '@queries';
import { ChevronRightIcon } from '@svgs';

import AccountSidebar from '../components/AccountSidebar/AccountSidebar.jsx';
import User from './User/User.jsx';

export const Users = () => {
  const { t } = useTranslation();
  const globals = useContext(GlobalContext);

  const [selectedGroupId, setSelectedGroupId] = useState('');

  const { data: groupData, isPending: isGroupsPending } = useQuery(
    groupsQuery({}),
  );

  // exclude the groups that have approved roles
  const groups =
    groupData?.objects?.filter((group) => {
      const groupKeys = Object.keys(GROUP_ROLES);
      const hasRole = group.roles.some((role) => groupKeys.includes(role));
      // return group if has approved role, or has no role
      return hasRole || group.roles.length === 0;
    }) || [];

  const {
    data: users,
    isPending,
    isError,
  } = useQuery(
    usersQuery({
      is_active: 1,
      limit: 500,
      ...(selectedGroupId ? { group_id: selectedGroupId } : {}),
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <AccountSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <span>Account settings</span>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>Users</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Users')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/users/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>
            <div className="sb-manage-content-head">
              <div
                className={
                  `sb-form-item-formgroup sb-form-item-select ` +
                  (isGroupsPending ? 'sb-form-item-loading' : '')
                }
                style={{ minWidth: 260 }}
              >
                <div
                  className="sb-form-item-content"
                  style={{ position: 'relative' }}
                >
                  <select
                    id="users-group-filter"
                    value={selectedGroupId}
                    onChange={(e) => setSelectedGroupId(e.target.value)}
                    disabled={isGroupsPending}
                  >
                    <option value="">{t('All groups')}</option>
                    {groups.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {isPending ? (
              <Loader className="sb-loader sb-loader-large" />
            ) : users?.objects?.length > 0 ? (
              <div className="sb-content-view-row">
                {users.objects.map((user) => {
                  return <User key={user.id} user={user} />;
                })}
              </div>
            ) : (
              <div className="sb-content-view-row">
                <p>No users found</p>
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
